import moment from "moment";

export const dateFormatter = (date, format = "MMMM Do YYYY, h:mm:ss a") =>
  moment(date).format(format);
